import { FieldArray, FormikProps } from 'formik';
import { t } from "i18next";
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import EasyFormColumn from '../../../components/Forms/EasyFormColumn';
import { FormType } from '../../../components/Forms/EasyFormMany';
import { EasyFormRow } from '../../../components/Forms/FormLayout';
import { AutocompleteFieldRender } from '../../../components/Forms/Renders/AutocompleteFieldRender';
import { FieldEditorRender } from '../../../components/Forms/Renders/FieldEditorRender';
import { TextFieldRender } from '../../../components/Forms/Renders/TextFieldRender';
import { FailoverEnum, failoverToString, SetupEnum, setupTypeToString } from '../../../models/CPE';
import HostingsiteBase from '../../../models/Hostingsite';
import { CreateOrganisationHostingSiteRequest, CreateOrganisationRequest, OrganisationCPE } from '../../../models/Organisation';
import { getCPEValidationScheme } from '../../HostingSiteApi/cpeSchemeValidation';


export function getCPEStepValidationScheme() {
  return Yup.object().shape({
    cpes: Yup.array().of(
      getCPEValidationScheme(true)
    ).test("unique_sdn_v4_ids", t("No SDN V4 ID duplicates allowed in same hosting site"),
      list => {
        const hsSdnV4Ids = list?.filter(cpe => cpe.sdn_v4_id != undefined && cpe.sdn_v4_id.length > 0).map(cpe => cpe.hosting_site?.uuid + cpe.sdn_v4_id);
        return hsSdnV4Ids == undefined || hsSdnV4Ids.length == new Set(hsSdnV4Ids).size;
      })
  });
}

function getRows(organisationRequest: CreateOrganisationRequest): Array<FieldEditorRender[]> {
  return organisationRequest.cpes?.map((cpe) => getCPEColumns(organisationRequest.hosting_sites, cpe.uuid)) ?? [];
}

export function getCPEColumns(hostingSites: CreateOrganisationHostingSiteRequest[], uniqueId: string): FieldEditorRender[] {
  return ([
    new TextFieldRender({
      displayText: "SDN V4 ID",
      showLabel: true,
      fieldName: "cpes",
      nestedfieldName: "sdn_v4_id",
      minWidth: 100,
      type: "text",
      columns: true,
      uniqueId: uniqueId
    }),
    new TextFieldRender({
      displayText: "Theft mark",
      showLabel: true,
      fieldName: "cpes",
      nestedfieldName: "theft_mark",
      minWidth: 100,
      type: "text",
      columns: true,
      uniqueId: uniqueId
    }),
  ])
}

export default function CPEStep(props: { formikProps: FormikProps<CreateOrganisationRequest>, formPropsStuf: any }) {
  const { t } = useTranslation();
  return (
    <FieldArray
      name="cpes"
      render={arrayHelpers => (
        <EasyFormRow
          confirmDeletionText={t("Are you sure you wish to remove this CPE?")}
          {...props.formikProps}
          {...props.formPropsStuf}
          editModeAlways={true}
          editable={true}
          isDeleteable={true}
          saveMutation={() => { throw "Dont save plz" }}
          formType={FormType.LIST}
          createNew={() => new OrganisationCPE()}
          editMode={true}
          getFieldRows={(organisationRequest) => getRows(organisationRequest as CreateOrganisationRequest)}
          columns={[
            new EasyFormColumn("CPE", "", [])
          ]}
          arrayHelpers={arrayHelpers} />
      )
      }
    />


  )
}
